export default "__VITE_ASSET__CsO8b$Yh__"